import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Product } from './model/product';
import { takeUntil, take } from 'rxjs/operators';
import { Subject, ReplaySubject } from 'rxjs';
import { MatSelect } from '@angular/material';
import { MatFormField, MatLabel, MatSelect as MatSelect_1, MatSelectTrigger, MatOption } from '@angular/material/select';
import { MatChipListbox, MatChipOption, MatChipRemove } from '@angular/material/chips';
import { NgFor, AsyncPipe, CurrencyPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@Component({
    selector: 'app-product-options',
    templateUrl: 'product-options.component.html',
    styleUrls: ['product-options.component.scss'],
    imports: [MatFormField, MatLabel, MatSelect_1, FormsModule, ReactiveFormsModule, MatSelectTrigger, MatChipListbox, NgFor, MatChipOption, MatIcon, MatChipRemove, MatOption, NgxMatSelectSearchModule, AsyncPipe, CurrencyPipe]
})
export class ProductOptionsComponent implements OnInit, OnDestroy {
  /**
 * @property Data binded to use in the component
 **/
  @Input() products: any;
  /**
   * @property mode read or edit
   **/
  @Input() selected: string[];
  /**
   * @property address values to be emitted
   **/
  @Output() emitSelectedProducts: EventEmitter<string[]> = new EventEmitter<string[]>();
  /**
   *@property preProducts holds the list of existing prodcts of the asi code which are provided by asiProductmapping component..
   **/
  public preProducts: string[];
  /**
   *@property selectedProducts holds the list of selected product id's.
   **/
  public selectedProducts: string[];
  /**
   *@property allProducts holds data of all the eligible products which are provided by asiproduct mapping component..
   **/
  public allProducts: Product[];
  /**
   *@property productsControl holds data of selected products changes.
   **/
  public productsControl: UntypedFormControl = new UntypedFormControl();
  /**
   *@property productMultiFilterCtrl control for the MatSelect filter keyword multi-selection.
   **/
  public productMultiFilterCtrl: UntypedFormControl = new UntypedFormControl();
  /**
   *@property multiSelect of type MatSelect
   **/
  @ViewChild('multiSelect', { static: false }) multiSelect: MatSelect;
  /**
   *@property _onDestroy Subject that emits when the component has been destroyed..
   **/
  protected _onDestroy = new Subject<void>();
  /**
   *@property filteredProductsMulti list of products filtered by search keyword.
   **/
  public filteredProductsMulti: ReplaySubject<Product[]> = new ReplaySubject<Product[]>(1);

  constructor() {
  }
  ngOnInit() {
    if (!!this.products) {
      this.allProducts = this.products;
      this.preProducts = this.selected;
      this.initialize();
      // load the initial bank list
      this.filteredProductsMulti.next(this.allProducts.slice());
    }
    // listen for search field value changes
    this.productMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBanksMulti();
      });
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
  /**
   * @method changeValue will emit Array of selected prodcut id or id's on change detection..
   * @returns void
   */
  public initialize(): void {
    if (!!this.preProducts) {
      this.selectedProducts = this.preProducts;
      let existing_products: any = [];
      existing_products = this.preProducts.map(i =>
        this.allProducts.find(j => j.productID === i)
      );
      this.allProducts = Object.values(
        existing_products
          .concat(this.allProducts)
          .reduce((r: { [x: string]: any }, o: { productID: string }) => {
            r[o.productID] = o;
            return r;
          }, {})
      );
      this.productsControl.setValue(existing_products);
    }
  }
  /**
   * @method onProductRemoved will emit Array of selected prodcut id or id's on change on removal of each *  * product.
   * @param string selected_id
   * @returns void
   */
  public onProductRemoved(selected_id: string): void {
    let products = this.productsControl.value as Array<Product>;
    products = products.filter(product => product.productID !== selected_id);
    this.selectedProducts.forEach((product_id, index) => {
      if (product_id === selected_id) { this.selectedProducts.splice(index, 1); }
    });
    this.emitSelectedProducts.emit(this.selectedProducts);
    this.productsControl.setValue(products); // To trigger change detection
  }
  /**
   * @method changeValue will emit Array of selected prodcut id or id's on change detection..
   * @returns void
   */
  public changeValue(value: object[]): void {
    this.selectedProducts = [];
    value.map((product: Product) => {
      this.selectedProducts.push(product.productID);
    });
    this.emitSelectedProducts.emit(this.selectedProducts.length > 0 ? this.selectedProducts : this.preProducts);
  }
  /**
   * @method filterBanksMulti filter the products based on searched attribute.
   * @returns void
   */
  protected filterBanksMulti(): void {
    if (!this.allProducts) {
      return;
    }
    // get the search keyword
    let search = this.productMultiFilterCtrl.value;
    if (!search) {
      this.filteredProductsMulti.next(this.allProducts.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the products
    this.filteredProductsMulti.next(
      this.allProducts.filter(product => (product.productName + product.brand + product.fnaProductCode + product.type + product.region + product.price).toLowerCase().indexOf(search) > -1)
    );
  }
}
